<template>
  <v-bottom-navigation color="accent" v-if="display" hide-on-scroll style="height: 55px" app class="app-bottom">
    <v-toolbar>
      <v-btn icon x-large @click="onMenu"
        ><div class="menu-item">Menu</div>
        <v-icon>mdi-menu</v-icon>
      </v-btn>
      <v-divider class="mx-4"></v-divider>
      <div v-for="item in menuItems" v-bind:key="item.id">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon x-large v-bind="attrs" v-on="on" :to="item.to">
            <div class="menu-item"></div>
            <v-icon>{{ item.icon }}</v-icon>
          </v-btn>
          </template>
          <span>{{ item.text }}</span>
        </v-tooltip>
        <v-divider class="mx-4"></v-divider>
      </div>
        <div class="menu-item">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" text @click="onToggleLocalization">
              <v-icon>mdi-swap-horizontal</v-icon>
            </v-btn>
            </template>
            <span>{{ local}}</span>
          </v-tooltip>
        </div>

    </v-toolbar>
  </v-bottom-navigation>
</template>

<script>
import { Loader } from "@/constants";
import menuService from "@/_services/menu-service.js"
import store from "@/store"

export default {
  name: "app-bottom-nav",
  components: {},
  computed: {
    display() {
      var rc = false;
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          rc = true;
          break;
        case "sm":
          rc = true;
          break;
        case "md":
          rc = false;
          break;
        case "lg":
          rc = false;
          break;
        case "xl":
          rc = false;
          break;
      }
      return rc;
    },
  },

  data: () => ({
    menuItems: [],
    local: "Espanola",
  }),

  methods: {
    filterMenuItems() {
      this.menuItems = [];
      const menuItems = menuService.get(Loader.bottom);
      menuItems.forEach(mi => {
        if(mi.subItems == 0 && mi.bottom){
          this.menuItems.push(mi)
        } else {
          mi.subItems.forEach(si => {
            if(si.bottom) {
              this.menuItems.push(si);
            }
          })
        }
      });
      this.local = store.getters.getLocalization ? "Espanola" : "English";
    },

    onMenu() {
      store.commit("toggleDrawer");
    },

    onToggleLocalization() {
      store.commit("toggleLocalization");
      this.local = store.getters.getLocalization ? "Espanola" : "English";
    },

  },

  mounted() {
    this.filterMenuItems();
  },

  store: store,
  watch: {
    "$store.state.user"() {
      this.filterMenuItems()
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/variables.scss";

.app-bottom {
  margin-bottom: 11px;
}
</style>
